import React from "react";

import {
    Item,
    ItemContainer,
    SubItem,
} from "../../TechnicShop/components/GroupTreeItem";
import { iCategory } from "../store";

type Props = {
    category: iCategory;
    handleNavigation: (category: iCategory) => void;
    selectedCategory: iCategory | null;
    isSub?: boolean;
    parent: number | null;
};
const CategoryTreeItem = ({
    category,
    handleNavigation,
    selectedCategory,
    isSub = false,
    parent,
}: Props) => {
    const ItemElement = isSub ? SubItem : Item;
    const isSelected =
        selectedCategory?.id === category.id ||
        (parent === category?.id && isSub === false);
    return (
        <ItemContainer className={isSub ? "sub" : ""}>
            <ItemElement
                onClick={() => {
                    handleNavigation(category);
                }}
                className={isSelected ? "active" : ""}
                isActive={isSelected}
            >
                {category.name}
            </ItemElement>
            {isSelected &&
                category.children &&
                category.children.map((item) => (
                    <CategoryTreeItem
                        key={item.id}
                        isSub={true}
                        selectedCategory={selectedCategory}
                        category={item}
                        handleNavigation={handleNavigation}
                        parent={parent}
                    />
                ))}
        </ItemContainer>
    );
};

export default CategoryTreeItem;
